import { ObjectReference } from '@totem/types/common';

export type { ObjectReference };

export type ApiConnectionType =
  | 'Acronis'
  | 'ConnectWise'
  | 'NozomiVantage'
  | 'Tempered_Conductor'
  | 'EndOfLife';

export const API_CONNECTION_TYPES: ApiConnectionType[] = [
  'Acronis',
  'ConnectWise',
  'NozomiVantage',
  'Tempered_Conductor',
  'EndOfLife',
];

export interface ConnectionGeneric {
  baseUrl?: string;
  clientId?: string;
  clientSecret?: string;
  token?: string;
  username?: string;
  password?: string;
  tenantUUID?: string;
  confirmed?: boolean;
}

export type ApiConnectionStatus = 'Active' | 'Inactive' | 'Deleted';

export interface ApiConnectionSummary {
  id: string;
  type: string;
  organization: ObjectReference;
  displayName: string;
  status: ApiConnectionStatus;
  createdAt: string;
}

export interface ApiConnection extends ApiConnectionSummary {
  data: ConnectionGeneric;
}

export interface ApiConnectionField {
  key: string;
  label: string;
  default?: string;
}

export interface ApiConnectionTypeField {
  type: string;
  fields: ApiConnectionField[];
}

export interface AirwallGroup {
  id: string;
  uuid: string;
  name: string;
  description: string;
  enabled: boolean;
}

export interface AirwallTag {
  id: string;
  name: string;
  ownership: string;
}

export interface TemperedConnectionTestRequest {
  baseUrl: string;
  clientId: string;
  token: string;
}
